import React, { useContext, useEffect, useState } from 'react';
import Card from '../../components/elements/Card';
import IconKeyFilled from '../../components/icons/IconKeyFilled';
import { AppContext } from '../../contexts';
import styles from './styles.scoped.css';
import ModalChangePassword from '../../components/fragments/ModalChangePassword';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChangePassword, fetchCountDown, resetAction } from './actions';

export default function Profile(){
  const { dataDetailUser } = useSelector((state) => state.pageBase);
  const { changePassword, countdown } = useSelector((state) => state.profile);
  const { setBreadcrumbs } = useContext(AppContext);
  const [modalChangePassword, setModalChangePassword] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setBreadcrumbs(['Profil']);
    dispatch(resetAction());
  }, []);

  useEffect(() => {
    if(!changePassword?.isLoading && changePassword?.message){
      setModalChangePassword(false);
      dispatch(resetAction());
    }
  }, [changePassword?.isLoading, changePassword?.message, changePassword?.code]);

  useEffect(() => {
    if(!countdown?.isLoading && countdown?.message && countdown?.code === 404){
      setModalChangePassword(true);
      dispatch(resetAction());
    }
  }, [countdown?.isLoading, countdown?.message, countdown?.code]);

  const handleChangePassword = () => {
    dispatch(fetchCountDown());
  };

  const handleSubmit = (val) => {
    const params = {
      currentPassword: val.password,
      newPassword: val.newPassword,
    };
    dispatch(fetchChangePassword(params));
  };

  const item = (label, value) => (
    <div className={styles.item}>
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );

  return(
    <div className={styles.container}>
      <Card className={styles.card}>
        <h4>Profile</h4>
        <div className={styles.content}>
          <h5>Data Diri</h5>
          {item('Nama', dataDetailUser.name)}
          {item('Email', dataDetailUser.email)}
          <div className={styles.line} />
          <div className={styles.cardChangePassword} onClick={handleChangePassword}>
            <IconKeyFilled />
            <div>
              <span>Perbarui Kata Sandi</span>
              <span>Ganti kata sandi lama dengan yang baru</span>
            </div>
          </div>
        </div>
        <ModalChangePassword
          closeBtn={{
            text: 'Batal'
          }}
          handleClose={() => setModalChangePassword(false)}
          handleSubmit={handleSubmit}
          isLoading={changePassword?.isLoading}
          open={modalChangePassword}
        />
      </Card>
    </div>
  );
}
